import { Component } from 'react';
import Await from './Await';
import { getPairing } from '../api/api';
import PropTypes from 'prop-types';

// Pairing cards:
import OrderDetailsCard_v2 from './pairing_cards_v2/OrderDetailsCard';
import MarketingCard from './pairing_cards_v2/MarketingCard';
import CustomizationCard from './pairing_cards_v2/CustomizationCard';

/*
The Pairing card is the parent of all the pairing card.

When creating a new version of the pairing card / feature card, RDP, import it in this file and
add it to the pairingCards object. Then pass the cardType prop to the PairingCard component in
other files to choose it like so for example:

<PairingCard cartType={0} />

props:
  pairingId: In case the pairingData prop is missing used to fetch the data from db.
  pairingData: this is the data passed to every pairingCard
  orderId: needed to send rating as it's a field in the pairing_rating model
  orderDate: this date is being displayed in the pairing cards in the dashboard.
  onRating: This is works almost like a callback function it's been called after a user send a rating
  cardType: Allows dev to choose which pairing card UI to use, the list is in the pairingCards variable

  Either the pairingData or the pairingId props needs to be passed to this Component or it will break.
 */

// All pairing cards:
let pairingCards = {
  1: OrderDetailsCard_v2,
  2: MarketingCard,
  3: CustomizationCard,
};

export default class PairingCard extends Component {
  // This is the pairing card itself.  As in, it's the element that get's clicked on.
  // It calls out to the back-end to get information about a particular paring, as well as send a POST with rating.
  constructor(props) {
    super(props);
    this.state = {
      pairingData: this.props.pairingData || null,
      // if data is passed to the card loading should be false as no
      // request will be sent to ge the data.
      loading: !this.props.pairingData,
    };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  componentDidMount() {
    if (!this.props.pairingData) {
      this.getPairingInfo();
    }
  }

  getPairingInfo() {
    getPairing(this.props.pairingId)
      .then((result) => {
        this.setState({ pairingData: result, loading: false });
      })
      .catch(console.error);
  }

  sendRating() {
    let pairingId = this.props.pairingId || this.state.pairingData.id;
    if (this.props.onRating) {
      this.props.onRating(pairingId);
    }
  }

  renderCorrectCard() {
    if (!this.state.pairingData) return;
    //Render the appropriate card depending on the data available
    let { orderDate } = this.props;
    let Card = pairingCards[this.props.cardType];

    const openPDPModal = this.props.togglePdpModal
      ? (sku) => {
          const product = typeof sku === 'object' ? sku : { id: sku };
          this.props.togglePdpModal(product);
        }
      : null;

    return (
      <Card
        customer={this.props.customer}
        orderDate={orderDate}
        onFavoriteChange={(isFavorite) => {
          this.setState({
            pairingData: {
              ...this.state.pairingData,
              is_favorited: isFavorite,
            },
          });
        }}
        onBinaryRating={() => this.sendRating()}
        pairingData={this.state.pairingData}
        orderId={this.props.orderId}
        openModal={this.props.onClick}
        openPDPModal={openPDPModal}
        loading={this.state.loading}
        showRatings={this.props.showRatings}
        isRecipesPage={this.props.isRecipesPage}
      />
    );
  }

  render() {
    const { testid, pairingId } = this.props;
    return (
      <Await loading={this.state.loading}>
        <div
          data-testid={`${testid}-pairing-card-${pairingId}`}
          className="pairing-card"
        >
          {this.renderCorrectCard()}
        </div>
      </Await>
    );
  }
}

PairingCard.propTypes = {
  pairingId: PropTypes.number,
  pairingData: PropTypes.object,
  orderId: PropTypes.number,
  orderDate: PropTypes.string,
  onRating: PropTypes.func,
  cardType: PropTypes.number.isRequired,
  showRatings: PropTypes.bool,
  // The onClick prop is passed by the modal to open it.
  onClick: PropTypes.func,
};
